<div class="view-container">
  <mat-card class="order-medicine-list-view">
    <div class="order-medicine-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>medication</mat-icon>
        </div>
        <div>
          <h1 class="mbp-page-header__title">Order System</h1>
          <p class="order-medicine-list__subtitle">Add or edit medicine for the customer order system.</p>
        </div>
      </div>

      <div class="order-medicine-list__header-actions">
        <mat-form-field
          appearance="outline"
          class="order-medicine-list__search"
          subscriptSizing="dynamic"
        >
          <input matInput placeholder="Search medicine" [formControl]="searchInput" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <a mat-flat-button color="primary" class="order-medicine-list__add-btn" routerLink="/portal/order-medicine/create">
          <mat-icon>add</mat-icon> Add medicine
        </a>
      </div>
    </div>

    <mat-paginator
      class="order-medicine-list__paginator"
      [length]="totalItems"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of order system"
    >
    </mat-paginator>

    <div class="order-medicine-list__table">
      <core-order-medicine-item-list
        (onDelete)="removeOrderItem($event)"
        [orderItems]="orderItems"
        [orderItemStatuses]="orderItemStatuses"
        [batchStatuses]="batchStatuses"
      ></core-order-medicine-item-list>
    </div>
  </mat-card>
</div>
